// NPM Imports
import React from "react";

const DashboardLoader = props => {
  const { message } = props;
  return (
    <div className="dashboardloader-wrapper">
      <span className="dashboardloader-message">{message}...</span>
    </div>
  );
};

export default DashboardLoader;



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/DashboardLoader/index.js